import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCloudDownloadBulk = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.516 8.758a.21.21 0 0 1-.183-.18c-.294-2.108-2.009-4.74-5.33-4.74-3.572 0-5.041 2.91-5.326 4.742a.21.21 0 0 1-.183.177c-2.36.29-3.957 2.098-3.957 4.583a4.64 4.64 0 0 0 2.74 4.222 5.1 5.1 0 0 0 1.465.357c.156.013.256-.158.194-.302a2.49 2.49 0 0 1 .526-2.744c.5-.501 1.16-.736 1.817-.722a.214.214 0 0 0 .222-.208v-1.526a2.5 2.5 0 1 1 5 0v1.526c0 .119.104.211.223.208a2.47 2.47 0 0 1 1.815.722c.743.742.916 1.833.527 2.743-.061.145.039.316.195.302.378-.033.9-.124 1.488-.36a4.64 4.64 0 0 0 2.715-4.218c0-2.483-1.593-4.29-3.948-4.582"
      clipRule="evenodd"
      opacity={0.4}
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m14.24 16.111-1.49 1.491v-5.184a.75.75 0 0 0-1.5 0v5.184l-1.49-1.491a.75.75 0 1 0-1.062 1.061l2.77 2.769q.105.106.247.165c.048.02.1.021.151.03.045.009.086.027.133.027s.09-.018.134-.027c.05-.009.102-.01.151-.03a.8.8 0 0 0 .248-.165l2.77-2.769a.75.75 0 1 0-1.062-1.061"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCloudDownloadBulk);
export default ForwardRef;
